/**
 * General — who you are, how the app behaves, and what it reports about itself.
 *
 * A shell, not a panel. Profile, the old Settings page, System, and About land
 * here. Diagnostics is its own page again.
 *
 * Section order is deliberate: identity, then behaviour, then the machine, then
 * the build. Danger sits at the bottom of General's own section, where it was.
 *
 * @module
 */
import { AboutSection } from "./AboutSection";
import { GeneralSection } from "./GeneralSection";
import { ProfileSection } from "./ProfileSection";
import { SettingsPageContainer } from "./settingsLayout";
import { SystemSection } from "./SystemSection";

export function GeneralSettings() {
  return (
    <SettingsPageContainer>
      <ProfileSection />
      <GeneralSection />
      <SystemSection />
      <AboutSection />
    </SettingsPageContainer>
  );
}
